<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        :aria-label="ariaLabel"
        role="img"
        fill="none"
    >
        <path
            :fill="color"
            d="M15 7.222h-4.094l3.546-2.047-.779-1.35-3.545 2.048 2.046-3.546-1.349-.779L8.78 5.093V1H7.22v4.094L5.174 1.548l-1.348.779 2.046 3.545-3.545-2.046-.779 1.348 3.546 2.047H1v1.557h4.093l-3.545 2.047.779 1.35 3.545-2.047-2.047 3.545 1.35.779 2.046-3.546V15h1.557v-4.094l2.047 3.546 1.349-.779-2.047-3.546 3.545 2.047.779-1.349-3.545-2.046h4.093L15 7.222zm-7 2.896a2.126 2.126 0 110-4.252 2.126 2.126 0 010 4.252z"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/**
 * LoomIcon.vue
 *
 * @description Loom brand icon SVG component.
 * @prop {number|string} size - Icon size in px or string (default: 24)
 * @prop {string} ariaLabel - Accessibility label (default: 'Loom icon')
 * @prop {string} color - Icon color (default: 'currentColor')
 */
export default defineComponent({
    name: "LoomIcon",
    props: {
        size: {
            type: [Number, String],
            default: 24,
        },
        ariaLabel: {
            type: String,
            default: "Loom icon",
        },
        color: {
            type: String,
            default: "currentColor",
        },
    },
})
</script>
